import { isMainScope, Scope } from './scopeUtilsLib';
import { useGetConfigurationRulesQuery } from './apiScopes';
import { TemplateOrCalculationWithValue } from '../../../apis/api';
import { useTemplateOrCalculationWithValue } from '../../../hooks/useTemplateOrCalculationWithValue';

export const useMainScope = (
  forcedTemplateOrCalculation?: TemplateOrCalculationWithValue,
): Scope | undefined => {
  const templateOrCalculation = useTemplateOrCalculationWithValue();

  const { scopes: scope } = useGetConfigurationRulesQuery(
    forcedTemplateOrCalculation ? forcedTemplateOrCalculation.value : templateOrCalculation.value,
    {
      selectFromResult: ({ data }) => {
        return { scopes: data?.find(isMainScope) };
      },
    },
  );

  return scope;
};
